// Generated by purs version 0.15.15
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Leibniz from "../Data.Leibniz/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
var ProofIsPartial = function (x) {
    return x;
};
var leTotalTotal = {};
var mostPartialTotalTotalTota = {
    Le0: function () {
        return undefined;
    },
    Le1: function () {
        return undefined;
    }
};
var lePartial = {};
var mostPartialPartialPartial = {
    Le0: function () {
        return undefined;
    },
    Le1: function () {
        return undefined;
    }
};
var mostPartialPartialTotalPa = {
    Le0: function () {
        return undefined;
    },
    Le1: function () {
        return undefined;
    }
};
var mostPartialTotalPartialPa = {
    Le0: function () {
        return undefined;
    },
    Le1: function () {
        return undefined;
    }
};
var isTotalityTotal = {
    isTotal: function (v) {
        return true;
    }
};
var isTotalityPartial = {
    isTotal: function (v) {
        return false;
    }
};
var eqProofIsPartial = {
    eq: function (v) {
        return function (v1) {
            return true;
        };
    }
};
var isTotal = function (dict) {
    return dict.isTotal;
};
var isPartial = /* #__PURE__ */ Control_Category.identity(Data_Leibniz.categoryLeibniz);
var absurd = function (v) {
    return Partial_Unsafe.unsafeCrashWith("You broke the universe!");
};
export {
    isTotal,
    ProofIsPartial,
    isPartial,
    absurd,
    isTotalityPartial,
    isTotalityTotal,
    lePartial,
    leTotalTotal,
    mostPartialTotalTotalTota,
    mostPartialTotalPartialPa,
    mostPartialPartialTotalPa,
    mostPartialPartialPartial,
    eqProofIsPartial
};
